export default __webpack_public_path__ + "static/media/exterior-3_cropped.ff33bf06.webp";